import Axios from "./axios";

const endpoint = "/api/invoice";

export default {
  //출고 등록
  //{"invoiceData": [{"constructionId": 0,"invoiceId": 0,"invoiceName": "string","orderId": [0],
  //"rebarList":[["string"]] }]}
  invoiceCreate: (data) => Axios.post(`${endpoint}/create`, data),

  //출고 삭제
  //{"invoiceId": 0}
  invoiceDelete: (data) => Axios.post(`${endpoint}/delete`, data),

  //출고 상세
  //{"invoiceId": 0}
  invoiceDetail: (data) => Axios.post(`${endpoint}/detail`, data),

  //출고목록 조건별 조회
  //{"companyName": "string","constructionId": 0,"constructionName": "string","endDate": "string",
  //invoiceId": 0,"invoiceName": "string","partName": "string","startDate": "string","userId": 0}
  invoiceFilterList: (data) => Axios.post(`${endpoint}/filter-list`, data),

  //출고를 위한 발주 목록 조회
  //{"constructionId": 0}
  invoiceOrderList: (data) => Axios.post(`${endpoint}/order-list`, data),

  /**
   * 출고 목록 전체 조회
   * @param {Number} constructionId
   * @param {Number} currentPage
   * @param {Text} endDate
   * @param {Text} keyword
   * @param {Text} order
   * @param {Number} pagingCount
   * @param {Text} startDate
   * @param {Text} type
   * @returns
   */
  invoiceTotalList: (data) => Axios.post(`${endpoint}/total-list`, data),

  //출고 수정
  //{"constructionId": 0,"invoiceId": 0,"orderId": [0],"rebarList": [["string"]]}
  invoiceUpdate: (data) => Axios.post(`${endpoint}/update`, data),

  invoiceReadMemo: (data) => Axios.post(`${endpoint}/read-memo`, data),

  invoiceWriteMemo: (data) => Axios.post(`${endpoint}/write-memo`, data),

  invoiceQr: (data) => Axios.post(`${endpoint}/qr`, data),

  invoiceComplete: (data) => Axios.post(`${endpoint}/complete`, data),

  /**
   * 발주 가공업체 조회
   * @param {number} constructionId
   * @returns
   */
  invoiceConstructionList: (data) =>
    Axios.post(`/api/company/construction-invoice-list`, data),

  /**
   * 필터 리스트 조회
   * @param {Number} constructionId 현장번호
   * @returns
   */
  invoiceFilterListSearch: (data) =>
    Axios.post(`${endpoint}/search-list`, data),
};
